module.exports = __webpack_public_path__ + "static/media/aa16.2909cc2b.jpg";